/**
 * @generated SignedSource<<eb9ba1be58cc3f46e47655236ac8ddf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageSidebar_package$data = {
  readonly link: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "PackageAutoHotelPriceUpdateSwitch_package" | "PackageStatus_package">;
  readonly " $fragmentType": "PackageSidebar_package";
};
export type PackageSidebar_package$key = {
  readonly " $data"?: PackageSidebar_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageSidebar_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageSidebar_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageStatus_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageAutoHotelPriceUpdateSwitch_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "1aa52b2213d2a1cd2363c9bae075179b";

export default node;
